import WeaLocaleProvider from "../../wea-locale-provider";
import { defultCkConfig, defaultAtwhoConfig } from "../propType";

const { getUserLanguage } = WeaLocaleProvider;

export const convertSpecialChar = str => {
  str = str.toString();
  str = str.replace(/<br>/gi, "\n");
  str = str.replace(/&nbsp;/gi, " ");
  str = str.replace(/&lt;/gi, "<");
  str = str.replace(/&gt;/gi, ">");
  str = str.replace(/&quot;/gi, '"');
  str = str.replace(/&amp;/gi, "&");
  return str;
};

export const restoreSpeicalStr = str => {
  str = str.toString();
  //需先转译
  str = str.replace(/&/gi, "&amp;");
  str = str.replace(/</gi, "&lt;");
  str = str.replace(/>/gi, "&gt;");
  //后转译
  str = str.replace(/\n/gi, "<br>");
  str = str.replace(/ /gi, "&nbsp;");
  str = str.replace(/\"/gi, "&quot;");
  return str;
};

// 内容转换
export const transfStr = (type, ids, list, lev2Type) => {
  let str = "";
  list.forEach(item => {
    if (type === "Upload" && lev2Type === "image") {
      let imgSrc = item.imgSrc;
      if (
        window.ecologyContentPath &&
        imgSrc.indexOf(window.ecologyContentPath) < 0
      ) {
        imgSrc = window.ecologyContentPath + imgSrc;
      }
      str += `<img src="${imgSrc}" alt="" />&#8203;`;
    }
    if (type === "Upload" && (lev2Type === "file" || lev2Type === "list")) {
      str +=
        `<a onclick="ecCom.WeaRichText.opendoc1(this,${item.fileid})" unselectable="off"` +
        'style="cursor:pointer;text-decoration:underline !important;margin-right:8px"' +
        `href="javascript:void(0);" contenteditable="false">${item.filename}</a>&#8203;`;
      if (item.showLoad) {
        str +=
          `&nbsp;<a unselectable='off' contenteditable='false'` +
          `href='javascript:try{downloadFile(\"${item.loadlink}\","${item.fileid}")}catch(e){window.open(\"${item.loadlink}\")}' ` +
          `style='cursor:pointer;text-decoration:underline;margin-right:8px'>下载(${item.filesize})</a><br>`;
      }
    }
    if (type === "Browser") {
      str +=
        `<a contenteditable='false' onclick="ecCom.WeaRichText.openAppLink(this,${item.id},${lev2Type})"` +
        'href="javascript:void(0);" unselectable="off" contenteditable="false"' +
        'style="cursor:pointer;text-decoration:underline !important;margin-right:8px">' +
        `${item.name || item.showname}</a>&#8203;`;
    }
  });
  return str;
};

// hash 生成id
export const getHash = () =>
  Math.random()
    .toString(36)
    .substr(2, 6);

export const clearEmptyChar = data =>
  data.replace(/[\u200B-\u200D\uFEFF]/g, "").replace("&#8203;", "");

// 过滤默认传入的带div的标签
export const filterValueOfDiv = data => {
  const preReg = new RegExp(/^<div id=\"wea_rich_text_default_font\"[^>]+\>/);
  if (preReg.test(data)) {
    data = data.replace(preReg, "").replace(/<\/div>$/, "");
  }
  return data;
};

// fix: 编辑提交后的文档,视频无法删除问题
export const transVideo = data => {
  if (data && data.indexOf("</video>") > -1) {
    data = data.replace(/<\/video>/g, "</video>&#8203;");
  }
  return data;
};

// 当前系统语言
export const getLang = () =>
  ({
    7: "zh-cn",
    8: "en",
    9: "zh"
  }[getUserLanguage()]);

// 得到默认字体 默认字体大小相关属性
export const checkDefaultFont = config => {
  if (!config) return {};
  // 1、直接通过ckeditor的属性 fontSize_defaultLabel， font_defaultLabel传的配置
  // 2、流程签字意见通过约定的属性fontSize_defaultSize， font_defaultFamily作为默认字体和字体大小的配置
  const {
    fontSize_defaultLabel,
    font_defaultLabel,
    fontSize_defaultSize,
    font_defaultFamily,
    font_defaultWeight
  } = config;
  const fontFamily =
    font_defaultLabel ||
    (font_defaultFamily && font_defaultFamily.split("/")[1]) ||
    "";
  const fontSize =
    fontSize_defaultLabel ||
    (fontSize_defaultSize && fontSize_defaultSize.split("/")[1]);
  return {
    hasDefaultFontFamily:
      fontFamily && config.font_names.indexOf(fontFamily) > -1,
    fontFamily,
    hasDefaultFontSize:
      fontSize && config.fontSize_sizes.indexOf(fontSize) > -1,
    fontSize,
    font_defaultWeight
  };
};

// 判断toolbar 是否有相关的配置属性
export const fillterToolbarStr = (toolbar, value) => {
  if (!toolbar || toolbar.length === 0) return false;
  const str = JSON.stringify(toolbar);
  return str.indexOf(value) > -1;
};

// Maximize Image 扩展判断 （渲染组件内部代码）
export const filterToolbar = toolbar => {
  let toolbarArr = toolbar;
  const hasMaximize = fillterToolbarStr(toolbarArr, "Maximize");
  const hasImage = fillterToolbarStr(toolbarArr, "Image");
  const hasVideo = fillterToolbarStr(toolbarArr, "Html5video");
  if (hasMaximize || hasImage || hasVideo) {
    toolbarArr = toolbarArr.map(tool => {
      let _tool = Array.isArray(tool) ? [].concat(tool) : { ...tool };
      if (Array.isArray(tool))
        _tool = tool.filter(
          item =>
            item !== "Maximize" && item !== "Image" && item !== "Html5video"
        );
      if (_tool.items)
        _tool.items = tool.items.filter(
          item =>
            item !== "Maximize" && item !== "Image" && item !== "Html5video"
        );
      return _tool;
    });
  }
  return toolbarArr;
};

// 获取最终ckConfig
export const getConfig = ckConfig => {
  const { font_en, font_zh, uploadUrl } = defultCkConfig;
  const defaultConfig = {
    ...defultCkConfig,
    language: getLang(),
    font_names: getLang() === "en" ? font_en + font_zh : font_zh + font_en,
    uploadUrl:
      ckConfig.uploadUrl && ckConfig.uploadUrl !== ""
        ? ckConfig.uploadUrl
        : uploadUrl
  };
  let extraPlugins = [
    "filetools",
    "pastetools",
    "pastefromword",
    "autolink",
    "openlink",
    "image2",
    "imagepaste",
    "uploadimage",
    "tableresizerowandcolumn"
  ];
  if (ckConfig.extraPlugins) {
    const extra = ckConfig.extraPlugins.split(",");
    extraPlugins = [...extraPlugins, ...extra];
  }
  if (ckConfig.placeholder) {
    // placeholder
    extraPlugins = [...extraPlugins, "confighelper"];
  }
  if (JSON.stringify(ckConfig.toolbar).indexOf("textindent") > -1) {
    // 首行缩进
    extraPlugins = [...extraPlugins, "textindent"];
  }

  let config = {
    ...defaultConfig,
    ...ckConfig,
    removePlugins: ckConfig.removePlugins
      ? `magicline,${ckConfig.removePlugins}`
      : "magicline", // magicline: 去掉红色分割线
    extraPlugins: extraPlugins.join(","),
    toolbar: filterToolbar(ckConfig.toolbar)
  };
  const defaultFontPrams = checkDefaultFont(config);
  if (defaultFontPrams.hasDefaultFontFamily) {
    config = {
      ...config,
      font_defaultLabel: defaultFontPrams.fontFamily,
      fontSize_defaultLabel: defaultFontPrams.fontSize
    };
  }
  return config;
};

// 获取默认字体 默认字体大小的div
export const connectDataWithDiv = (ckConfig, content) => {
  const {
    hasDefaultFontFamily,
    fontFamily,
    hasDefaultFontSize,
    fontSize,
    font_defaultWeight
  } = checkDefaultFont(ckConfig);
  if ((hasDefaultFontFamily || hasDefaultFontSize) && content) {
    const pre = '<div id="wea_rich_text_default_font" style="';
    let style = "";
    if (hasDefaultFontFamily) {
      style += `font-family:${fontFamily};`;
    }
    if (hasDefaultFontSize) {
      style += `font-size:${fontSize};`;
    }
    if (font_defaultWeight) {
      style += `font-weight:${font_defaultWeight};`;
    }
    content = `${pre}${style}">${content}</div>`;
  }
  return content;
};

// 过滤extentsConfig中 at相关配置
export const getAtConfigInExtendsConfig = extentsConfig =>
  extentsConfig.filter(item => item.name === "At")[0];

// get atwho config
export const getAtwhoConfig = (extentsConfig, otherConfig) => {
  const configInExtendsConfig = getAtConfigInExtendsConfig(extentsConfig);
  const apiRequest =
    !configInExtendsConfig.data || configInExtendsConfig.data.length === 0; // 是否走接口请求@数据 - 默认传了data表示渲染传入的数据
  let atwhoConfig = {
    ...configInExtendsConfig, // 通过props的extentsConfig传入的@相关配置
    ...defaultAtwhoConfig, // 默认的config
    ...otherConfig, // 组件内部才能拿到的方法和事件
    isEn: getLang() === "en",
    pageSize: configInExtendsConfig.pageSize || defaultAtwhoConfig.pageSize,
    apiRequest
  };
  if (!apiRequest) {
    // 传入的data 匹配atwho.js 需要的数据格式
    let allatids = ",";
    const filterData = configInExtendsConfig.data.map(
      ({ uid, data, datapy }) => {
        if (allatids.indexOf("," + uid + ",") === -1) {
          allatids += uid + ",";
          return { id: uid, name: data, py: datapy };
        }
      }
    );
    atwhoConfig = {
      ...atwhoConfig,
      data: filterData
    };
  }
  return atwhoConfig;
};

export const transStyleObjToString = (styleObj, filterName) => {
  let str = "";
  if (Object.keys(styleObj).length > 0) {
    Object.keys(styleObj).map(item => {
      if (!filterName || item !== filterName) {
        str += `${item}:${styleObj[item]};`;
      }
    });
  }
  return str;
};

export const filterDomNode = (children, fontStyleStr, pStyleStr) => {
  if (children.length > 0) {
    const tableTags = ["TABLE", "TBODY", "THEAD", "TFOOT", "TR", "COLGROUP"];
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (tableTags.indexOf(child.nodeName) > -1) {
        // table相关（除了td）不处理
        continue;
      } else if (child.nodeName === "P") {
        // p标签添加样式
        child.setAttribute("style", pStyleStr);
      } else if (child.nodeName === "LI") {
        // td | li 添加文本样式,并保留之前的样式
        const oldStyleStr = child.getAttribute("style");
        const oldStyleArr = oldStyleStr ? oldStyleStr.split(";") : [];
        const fontStyleArr = fontStyleStr ? fontStyleStr.split(";") : [];
        const newStyleArr = [...oldStyleArr, ...fontStyleArr];
        const newStyleStr = newStyleArr.join(";");
        child.setAttribute("style", newStyleStr);
      } else {
        // 移除其他标签的style属性
        child.removeAttribute("style");
      }
      const newChildren = child.children;
      filterDomNode(newChildren, fontStyleStr, pStyleStr);
    }
  }
};

export const formatImgOrVideo = (list, display, style, wrapParams) => {
  if (list.length === 0) return;
  const { pStyleStr, centerStyleStr, mormalStyleStr, wrapStyle } = wrapParams;
  for (let i = 0; i < list.length; i++) {
    // 1: 配置img | video标签样式
    const item = list[i];
    const styleStr = transStyleObjToString(style);
    item.setAttribute("style", styleStr);
    // 2: 配置包裹的p标签样式
    if (display === "block" && typeof wrapStyle === "object") {
      // 整行显示
      const parent = item.parentNode;
      if (parent.nodeName === "P") {
        const childNodes = parent.childNodes;
        if (childNodes.length > 0) {
          let changed = false; // 标记当前的节点后的节点是否需要外包p标签
          for (let k = 0; k < childNodes.length; k++) {
            const child = childNodes[k];
            if (child.nodeType === 3) {
              // 文本节点
              child.nodeValue = clearEmptyChar(child.nodeValue).trim();
              if (child.nodeValue !== "") {
                if (changed) {
                  const newP = document.createElement("p");
                  newP.setAttribute("style", pStyleStr);
                  $(child).wrap(newP);
                } else {
                  parent.setAttribute("style", pStyleStr);
                  changed = true;
                }
              }
            } else if (child.nodeType === 1) {
              // element节点
              if (changed) {
                const newP = document.createElement("p");
                if (
                  wrapStyle["text-align"] &&
                  wrapStyle["text-align"] === "center"
                ) {
                  newP.setAttribute("style", centerStyleStr);
                } else {
                  newP.setAttribute("style", mormalStyleStr);
                }
                $(child).wrap(newP);
              } else {
                if (
                  wrapStyle["text-align"] &&
                  wrapStyle["text-align"] === "center"
                ) {
                  parent.setAttribute("style", centerStyleStr);
                } else {
                  parent.setAttribute("style", mormalStyleStr);
                }
                changed = true;
              }
            }
          }
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ecology9/wea-rich-text/util/index.js